import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import moment from 'moment';
import { DateFieldContainer, DateFieldNarrow, DateFieldWide, DateFieldMid, } from './DateSelect.styles';
import { range } from '../../../util';
var currentYear = moment().year();
var DateSelect = function (props) {
    var day = props.day, month = props.month, year = props.year, _a = props.minYear, minYear = _a === void 0 ? currentYear - 10 : _a, _b = props.maxYear, maxYear = _b === void 0 ? currentYear + 5 : _b;
    var validateDays = function (month, year) {
        var nonLeapYear = '2022';
        var length = moment("".concat(year !== '' ? year : nonLeapYear, ":").concat(month), 'YYYY-MMMM').daysInMonth();
        return !(length < Number(day));
    };
    var renderDays = function () {
        var length = month && year ? moment("".concat(year, ":").concat(month), 'YYYY-MMMM').daysInMonth() : 31;
        var output = new Array(length).fill('');
        return output.map(function (val, i) {
            return (React.createElement(MenuItem, { key: i + 1, value: i + 1 }, i + 1));
        });
    };
    var renderMonths = function () {
        return moment.months().map(function (val, i) {
            return (React.createElement(MenuItem, { key: val, value: val }, val));
        });
    };
    var renderYears = function () {
        return Array.from(range(minYear, maxYear + 1)).map(function (val) {
            return (React.createElement(MenuItem, { key: val, value: val }, val));
        });
    };
    return (React.createElement(DateFieldContainer, null,
        React.createElement(DateFieldNarrow, null,
            React.createElement(TextField, { fullWidth: true, id: "date-select-day", select: true, label: "Date", value: day, onChange: function (event) {
                    props.onChange({
                        day: event.target.value,
                        month: month,
                        year: year,
                    });
                } }, renderDays())),
        React.createElement(DateFieldWide, null,
            React.createElement(TextField, { fullWidth: true, id: "date-select-month", select: true, label: "Month", value: month, onChange: function (event) {
                    props.onChange({
                        day: validateDays(event.target.value, year) ? day : '',
                        month: event.target.value,
                        year: year,
                    });
                } }, renderMonths())),
        React.createElement(DateFieldMid, null,
            React.createElement(TextField, { fullWidth: true, id: "date-select-year", select: true, label: "Year", value: year, onChange: function (event) {
                    if (month !== '') {
                        props.onChange({
                            day: validateDays(month, event.target.value) ? day : '',
                            month: month,
                            year: event.target.value,
                        });
                    }
                    else {
                        props.onChange({
                            day: day,
                            month: month,
                            year: event.target.value,
                        });
                    }
                } }, renderYears()))));
};
export default DateSelect;
